(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('showcases', {
                parent: 'admin',
                url: '/showcases',
                data: {
                    authorities: ['STORE_READ_SHOWCASE'],
                    pageTitle: 'showcases.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcases/showcases.html',
                        controller: 'ShowcasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('store-management');
                        $translatePartialLoader.addPart('bag');
                        $translatePartialLoader.addPart('showcase-layout-template');
                        return $translate.refresh();
                    }]

                }
            })
            .state('showcases.new', {
                parent: 'showcases',
                url: '/new',
                data: {
                    authorities: ['STORE_CREATE_SHOWCASE'],
                    pageTitle: 'showcases.detail.title',
                    specialClass: "fixed-sidebar md-skin fixed-nav"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcases/showcases-detail.html',
                        controller: 'ShowcasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('showcase-layout-template');
                        return $translate.refresh();
                    }]

                }
            })
            .state('showcases.edit', {
                parent: 'showcases',
                url: '/{showcaseId:int}',
                data: {
                    authorities: ['STORE_UPDATE_SHOWCASE'],
                    pageTitle: 'showcases.detail.title',
                    specialClass: "fixed-sidebar md-skin fixed-nav"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcases/showcases-detail.html',
                        controller: 'ShowcasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        $translatePartialLoader.addPart('showcase-layout-template');
                        return $translate.refresh();
                    }]

                }
            })
            .state('showcases-flyers', {
                parent: 'showcases',
                url: '/flyers/{showcaseId}',
                data: {
                    authorities: ['STORE_READ_FLYER', 'STORE_CREATE_SHOWCASE', 'STORE_UPDATE_SHOWCASE'],
                    pageTitle: 'showcases.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcases/showcases-flyers.html',
                        controller: 'ShowcasesFlyersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    flyersId: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('flyers');
                        return $translate.refresh();
                    }]

                }
            })
            .state('showcases-layout-templates', {
                parent: 'showcases',
                url: '/{showcaseId:int}/layout-templates',
                data: {
                    authorities: ['STORE_CREATE_SHOWCASE', 'STORE_UPDATE_SHOWCASE'],
                    pageTitle: 'showcases.layout-templates-list.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/showcases/showcases-layout-templates.html',
                        controller: 'ShowcasesLayoutTemplatesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    ownerId: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('showcases');
                        $translatePartialLoader.addPart('showcase-layout-template');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
